import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LiveClassSharedModule } from '../live-class-shared/live-class-shared.module';
import { LiveClassUnavailable } from './live-class-unavailable.component';
import { TranslatePipeModule } from '../../shared/translate.pipe';

@NgModule({
  imports: [CommonModule, LiveClassSharedModule, TranslatePipeModule],
  declarations: [LiveClassUnavailable],
  exports: [LiveClassUnavailable],
})
export class LiveClassUnavailableModule {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-unavailable/live-class-unavailable.module.ts